/* import __COLOCATED_TEMPLATE__ from './salesforce-task-creation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();